export default class MoreDisplayYokarepo {
  constructor (moreDisplayYokarepoBtnElem, moreDisplayYokarepoWrapperElem, moreDisplayYokarepoTxtElem, limitHeightRem) {
    const isShowMoreDisplayYokarepoWrapperElem = moreDisplayYokarepoWrapperElem.classList.contains('u-hide');

    moreDisplayYokarepoWrapperElem.classList.remove('u-hide');
    if (moreDisplayYokarepoTxtElem.offsetHeight > this.convertRemToPx(limitHeightRem)) {
      moreDisplayYokarepoTxtElem.classList.remove('is-active');
      moreDisplayYokarepoBtnElem.classList.remove('u-hide');
      moreDisplayYokarepoBtnElem.classList.add('js-event-open');
      moreDisplayYokarepoBtnElem.addEventListener('click', {
        params: { moreDisplayYokarepoTxtElem: moreDisplayYokarepoTxtElem },
        handleEvent: this.addEvent
      });
    }
    if (isShowMoreDisplayYokarepoWrapperElem) {
      moreDisplayYokarepoWrapperElem.classList.add('u-hide');
    }
  }

  convertRemToPx (rem) {
    const fontSize = getComputedStyle(document.documentElement).fontSize;
    return rem * parseFloat(fontSize);
  }

  addEvent (event) {
    event.preventDefault();
    const target = event.currentTarget;

    if (target.classList.contains('js-event-open')) {
      target.classList.add('js-event-close');
      target.classList.add('is-active');
      target.classList.remove('js-event-open');
      target.querySelector('span').innerHTML = '閉じる';
      this.params.moreDisplayYokarepoTxtElem.classList.add('is-active');
    } else {
      target.classList.add('js-event-open');
      target.classList.remove('is-active');
      target.classList.remove('js-event-close');
      target.querySelector('span').innerHTML = '続きをみる';
      this.params.moreDisplayYokarepoTxtElem.classList.remove('is-active');
    }
  }
}
